import React from 'react';
import { motion } from 'framer-motion';

import DarkVeil from './reactbit/DarkVeil';
import './HeroSection.css';

const headline = "Together for a Stronger and Sustainable Future";
const subheading = "We create lasting solutions in education, environment, youth, and digital transformation.";

const HeroSection = () => {
  return (
    <section className="hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
      {/* DarkVeil arka planı */}
      <div style={{
        // 100vw kaydırma çubuğunu da sayıyor ve mobilde 100vh adres çubuğuyla
        // birlikte değişiyordu; bölümün kendi ölçüsünü kullanmak ikisini de çözer.
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 0,
        pointerEvents: 'none'
      }}>
        <DarkVeil />
      </div>
      {/* İçerik */}
      <div className="hero-content" style={{ position: 'relative', zIndex: 2 }}>
        <motion.h1
          className="hero-title"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          {headline}
        </motion.h1>
        <motion.p
          className="hero-description"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          {subheading}
        </motion.p>
      </div>
    </section>
  );
};

export default HeroSection;